import { Box, Typography } from '@mui/material';
import OfferIdsTable from './components/OfferIdsTable';

const OfferIdsPage = () => {
  const rows = [];

  return (
    <Box>
      <Typography variant='h4' sx={{ mb: 3 }}>
        OfferIDs
      </Typography>

      <Box sx={{ height: '67vh' }}>
        <OfferIdsTable rows={rows} />
      </Box>
    </Box>
  );
};

export default OfferIdsPage;
